{
  "loading": "Cargando…",
  "loadingMore": "Cargando más…"
}
